import CONFIG_KEYS from "../config";
import { customFetch } from "../middlewares/custom-fetch";

// Self-contained client for the in-app help assistant (api/AiAssistant/*). Mirrors
// QuestionBankService — calls the endpoint directly through customFetch (auth + error
// handling), so it does not depend on regenerating generated/api.ts.
type Envelope<T> = { status?: string; isSuccess?: boolean; message?: string; data?: T | null };

export type AiChatRole = "user" | "assistant";

export interface AiChatMessage {
  role: AiChatRole;
  content: string;
}

export interface AiChatRequest {
  messages: AiChatMessage[];
  language?: string;
  /** Grounding context (relevant help-article text) retrieved on the client. */
  context?: string;
}

export interface AiChatResponse {
  reply: string;
}

export class AiAssistantService {
  private readonly base = `${CONFIG_KEYS.baseUrl}/api/AiAssistant`;

  /** Sends the recent conversation and returns the assistant's next reply text. */
  public async SendMessage(request: AiChatRequest): Promise<string | undefined> {
    const res = await customFetch(`${this.base}/sendAssistantMessage`, {
      method: "POST",
      body: request as any,
    });
    const body = (await res.json()) as Envelope<AiChatResponse>;
    if (body?.isSuccess === false) {
      throw new Error(body?.message || "The assistant is currently unavailable.");
    }
    return body?.data?.reply ?? undefined;
  }
}

export const aiAssistantService = new AiAssistantService();
